<template>
    <b-modal ref="newPrivateTaskModal" title="Opret privat begivenhed" @ok="save">
        <validate-form ref="form">


            <FormGroup label="Dato fra" rules="required">
                <template #input="{state, invalid}">
                    <b-form-datepicker v-model="item.dateStart"
                                       locale="da"
                                       start-weekday="1"
                                       hide-header
                                       label-help=""
                                       :class="{ 'is-invalid': invalid }"
                                       :date-format-options="{ 'month': 'short', 'day': 'numeric', 'year': 'numeric' }"></b-form-datepicker>
                </template>
            </FormGroup>


            <FormGroup label="Tidspunkt fra" rules="required">
                <template #input="{state, invalid}">
                    <b-form-timepicker v-model="item.timeStart"
                                       locale="da"
                                       minutes-step="15"
                                       hide-header
                                       :class="{ 'is-invalid': invalid }"></b-form-timepicker>
                </template>
            </FormGroup>


            <FormGroup label="Dato til" rules="required">
                <template #input="{state, invalid}">
                    <b-form-datepicker v-model="item.dateEnd"
                                       locale="da"
                                       start-weekday="1"
                                       hide-header
                                       label-help=""
                                       :class="{ 'is-invalid': invalid }"
                                       :date-format-options="{ 'month': 'short', 'day': 'numeric', 'year': 'numeric' }"></b-form-datepicker>
                </template>
            </FormGroup>


            <FormGroup label="Tidspunkt til" rules="required">
                <template #input="{state, invalid}">
                    <b-form-timepicker v-model="item.timeEnd"
                                       locale="da"
                                       minutes-step="15"
                                       hide-header
                                       :class="{ 'is-invalid': invalid }"></b-form-timepicker>
                </template>
            </FormGroup>

            <div
                 class="d-flex gap-20 align-items-center mt-7 mb-8">
                <span class="font-weight-bold">Privat begivenhed</span>
                <b-form-checkbox v-model="item.private" class="mr-0" switch inline />
            </div>

            <FormGroup label="Titel" rules="" v-if="!item.private">
                <template #input="{state}">
                    <b-form-input v-model="item.title" :state="state"></b-form-input>
                </template>
            </FormGroup>

            <FormGroup label="Beskrivelse" rules="" v-if="!item.private">
                <template #input="{state}">
                    <b-form-input v-model="item.description" :state="state"></b-form-input>
                </template>
            </FormGroup>

        </validate-form>


        <template #modal-footer="{ ok, cancel, hide }">
            <b-button size="md" variant="secondary" @click="cancel()">
                Fortryd
            </b-button>

            <b-button size="md" variant="success" @click="ok()" :disabled="loading">
                <div v-if="loading" class="d-flex">
                    <b-spinner small class="mr-7"></b-spinner>
                    <span>Gemmer...</span>
                </div>
                <span v-else>Opret begivenhed</span>
            </b-button>
        </template>
    </b-modal>
</template>

<script>
    export default {
        components: {},
        props: {},
        data: () => ({
            item: {
                dateStart: null,
                timeStart: null,
                dateEnd: null,
                timeEnd: null
            },

            loading: false
        }),
        computed: {},
        created() {
            this.$_debounceTimer = null

        },
        mounted() { },
        methods: {
            save(e) {
                e.preventDefault()

                this.$refs.form.validate().then(success => {
                    if (success) {
                        this.loading = true
                        this.$http.post("/api/dashboard/calendar/tasks/create", this.item).then(x => {
                            this.loading = false

                            this.$emit("success", x.data)

                            this.$refs.newPrivateTaskModal.hide()
                        }).catch(x => {
                            this.loading = false

                            alert("Der opstod en fejl! Din bruger er muligvis ikke koblet til Office365.\nGå til din profil i højre hjørne for at koble din bruger til Office365.")
                        })
                    }
                })
            },

            debounce(method, timer) {
                if (this.$_debounceTimer !== null) {
                    clearTimeout(this.$_debounceTimer)
                }
                this.$_debounceTimer = setTimeout(() => {
                    method()
                }, timer)
            }

        },
    }
</script>